import Card from "@mui/material/Card"
import CardMedia from "@mui/material/CardMedia"
import Typography from "@mui/material/Typography"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"

import { useState } from "react"

import styles from "./styles.module.scss"

const Component = ({ data }) => {
  const [previewOpen, setPreviewOpen] = useState(false)
  const fullImage = data.previewImage || data.image

  const handleOpenPreview = () => setPreviewOpen(true)
  const handleClosePreview = () => setPreviewOpen(false)

  return (
    <div className={styles.cardContainer}>
      <Card className={styles.card} sx={{ maxWidth: 345 }}>
        <button
          type="button"
          onClick={handleOpenPreview}
          className={styles.imageButton}
          aria-label={`查看 ${data.title} 大图`}
        >
          <CardMedia
            className={styles.cardImage}
            component="img"
            image={data.image}
            alt={data.title}
            loading="lazy"
          />
          <div className={styles.hoverPanel}>
            <p>ID: {data.id}</p>
            <p>昵称: {data.nickname}</p>
            <a
              href={fullImage}
              download={`${data.id}_${data.title}.png`}
              target="_blank"
              rel="noreferrer"
              onClick={(event) => event.stopPropagation()}
              className={styles.downloadBtn}
            >
              下载图片
            </a>
          </div>
        </button>
        <Typography
          className={styles.cardTitle}
          gutterBottom
          variant="h5"
          component="div"
        >
          {data.title}
        </Typography>
      </Card>
      <Dialog open={previewOpen} onClose={handleClosePreview} maxWidth="md">
        <DialogContent>
          <img
            className={styles.previewImage}
            src={fullImage}
            alt={data.title}
          />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default Component
